import React from "react";

import { NavigationSplitViewGroupType, NavigationSplitViewOnTileClickedProps } from "models";

import { Flex, NavigationSplitViewTile } from "components";

export type NavigationSplitViewGroupProps = {
  group: NavigationSplitViewGroupType;
  selectedGroupIndex: number;
  selectedSubGroupIndex: number;
  selectedTileIndex: number;
  groupIndex: number;
  handleTileClicked: ({ groupIndex, subGroupIndex, tileIndex }: NavigationSplitViewOnTileClickedProps) => void;
  dataTestId?: string;
};

export const NavigationSplitViewGroup = ({
  group,
  selectedGroupIndex,
  selectedSubGroupIndex,
  selectedTileIndex,
  groupIndex,
  handleTileClicked,
  dataTestId,
}: NavigationSplitViewGroupProps) => {
  const showGroupTitle = group.subGroups.some((subGroup) => subGroup.tiles.some((tile) => tile.show));

  return showGroupTitle ? (
    <Flex className="margin-bottom-200" data-testid={dataTestId} key={`group-${groupIndex}`} vertical={true} gap="1rem">
      <p className="paragraph-l-bold padding-left-100" data-testid={`${dataTestId}-title`}>
        {group.title}
      </p>
      {group.subGroups.map((subGroupItem, subGroupIndex) => {
        const showSubGroupTitle = subGroupItem.tiles.some((tile) => tile.show);

        return showSubGroupTitle ? (
          <Flex vertical={true} gap={"1rem"} key={`group-${groupIndex}-subgroup-${subGroupIndex}`}>
            {subGroupItem.subtitle && (
              <p className="paragraph-m-bold padding-left-100" data-testid={`${dataTestId}-subgroup-${subGroupIndex}-title`}>
                {subGroupItem.subtitle}
              </p>
            )}
            {subGroupItem.tiles.map((tile, tileIndex) => (
              <NavigationSplitViewTile
                key={tileIndex}
                tile={tile}
                selectedTileIndex={selectedTileIndex}
                selectedSubGroupIndex={selectedSubGroupIndex}
                selectedGroupIndex={selectedGroupIndex}
                groupIndex={groupIndex}
                subGroupIndex={subGroupIndex}
                tileIndex={tileIndex}
                onTileClicked={handleTileClicked}
                dataTestId={`${dataTestId}-subgroup-${subGroupIndex}-tile`}
              />
            ))}
          </Flex>
        ) : null;
      })}
    </Flex>
  ) : null;
};
